import { useState } from "react";
import { Button } from "@/components/ui/button";
import logoFull from "@/assets/logo-full.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border shadow-sm">
      <nav className="container mx-auto px-4 py-4 flex items-center justify-between">
        <img 
          src={logoFull} 
          alt="Minha Casa Mais Bonita" 
          className="h-16 md:h-20 cursor-pointer"
          onClick={() => scrollToSection("hero")}
        />
        
        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-6">
          <button
            onClick={() => scrollToSection("sobre")}
            className="text-foreground hover:text-primary transition-colors font-medium"
          >
            Sobre o Programa
          </button>
          <button
            onClick={() => scrollToSection("quem-pode")}
            className="text-foreground hover:text-primary transition-colors font-medium"
          >
            Quem Pode Participar
          </button>
          <button
            onClick={() => scrollToSection("como-funciona")}
            className="text-foreground hover:text-primary transition-colors font-medium"
          >
            Como Funciona
          </button>
          <Button 
            onClick={() => window.open("https://forms.gle/jiHcGPWw6gXNCiWM8", "_blank")}
            className="bg-gradient-to-r from-[hsl(var(--orange-strong))] to-[hsl(var(--orange-medium))] hover:opacity-90 transition-opacity rounded-full px-6"
          >
            Quero minha casa mais bonita
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Menu"
        >
          <div className="w-6 h-5 flex flex-col justify-between">
            <span className={`block h-0.5 w-full bg-primary transition-all ${isOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`block h-0.5 w-full bg-primary transition-all ${isOpen ? 'opacity-0' : ''}`} />
            <span className={`block h-0.5 w-full bg-primary transition-all ${isOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </div>
        </button>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="absolute top-full left-0 right-0 bg-background border-b border-border shadow-lg md:hidden">
            <div className="container mx-auto px-4 py-6 flex flex-col gap-4">
              <button
                onClick={() => scrollToSection("sobre")}
                className="text-foreground hover:text-primary transition-colors font-medium text-left py-2"
              >
                Sobre o Programa
              </button>
              <button
                onClick={() => scrollToSection("quem-pode")}
                className="text-foreground hover:text-primary transition-colors font-medium text-left py-2"
              >
                Quem Pode Participar
              </button>
              <button
                onClick={() => scrollToSection("como-funciona")}
                className="text-foreground hover:text-primary transition-colors font-medium text-left py-2"
              >
                Como Funciona
              </button>
              <Button 
                onClick={() => window.open("https://forms.gle/jiHcGPWw6gXNCiWM8", "_blank")}
                className="bg-gradient-to-r from-[hsl(var(--orange-strong))] to-[hsl(var(--orange-medium))] hover:opacity-90 transition-opacity rounded-full w-full"
              >
                Quero minha casa mais bonita
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
